import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import HeroSection from "./components/HeroSection";
import ProblemSection from "./components/ProblemSection";
import SolutionSection from "./components/SolutionSection";
import AboutSection from "./components/AboutSection";
import VendorsSection from "./components/VendorsSection";
import RidersSection from "./components/RidersSection";
import WaitlistSection from "./components/WaitlistSection";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import WhatsAppButton from "@/components/feature/WhatsAppButton";

export default function HomePage() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <AboutSection />
        <VendorsSection />
        <RidersSection />
        <WaitlistSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}